import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  margin: 0 auto;

  background-color: #fff;
  overflow-y: auto;
`;

export const Header = styled.div`
  position: relative;
  background-color: #fff;
  padding: 3em 20px;

  ${handleQuery(css`
    padding: 4em 0 3em 20px;
  `)}
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1em;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 auto;

  ${handleQuery(css`
    margin-top: 0.5em;
    justify-content: flex-start;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  `)}

  -webkit-overflow-scrolling: touch;

  white-space: nowrap;

  & > * {
    flex-shrink: 0;
  }
`;

export const ButtonEmpretec = styled.button`
  border: none;
  padding: 12px;
  border-radius: 100px;
  cursor: pointer;
  transition: 'background-color 0.3s ease';
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ bgColor }) =>
    css`
      background-color: ${bgColor};
    `}
`;

export const ButtonClose = styled.button`
  position: absolute;
  top: 3em;
  right: 1em;
  background-color: ${({ bgColor }) => bgColor || 'transparent'};
  color: #fff;
  border: none;
  border-radius: 50%;
  padding: 0.5em 0.5em;
  font-size: 1.25em;
  cursor: pointer;
  z-index: 10;
  font-family: 'Inter', sans-serif;
  width: 25px;
  height: 25px;

  ${handleQuery(css`
    top: 1em;
    width: 25px;
    height: 25px;
  `)}
`;

export const Wrapper = styled.div`
  display: flex;
  height: 500px;

  ${({ bgColor }) =>
    css`
      background-color: ${bgColor};
    `}
  ${handleQuery(css`
    justify-content: space-between;
    height: 100%;
  `)}
`;

export const ContentWraper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0 2em;
  ${handleQuery(css`
    padding: 1em;
    width: 200px;
  `)}
`;

export const ContentImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 50%;
`;

export const ButonCTA = styled.button`
  border: none;
  background-color: #fff;
  padding: 14px 30px;
  border-radius: 100px;
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  font-size: 1em;
  width: 330px;
  cursor: pointer;
  ${({ colorText }) =>
    css`
      color: ${colorText && colorText};
    `}

  ${({ bgColor }) =>
    css`
      background-color: ${bgColor && bgColor};
    `}

    ${handleQuery(css`
    font-size: 0.8em;
    width: 260px;
    padding: 1em;
    z-index: 999;
  `)}
`;

export const Text = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1em;
  font-weight: 400;
  line-height: normal;
  padding: 3px 0;

  ${({ colorText }) =>
    css`
      color: ${colorText};
    `}

  ${handleQuery(css`
    font-size: 0.85em;
    padding: 8px 0;
  `)}
`;

export const TextHeading = styled.h1`
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  line-height: normal;
  padding: 3px 0;
  font-size: 1.75em;

  ${({ colorText }) =>
    css`
      color: ${colorText};
    `}

  ${handleQuery(css`
    font-size: 1em;
    padding: 8px 0;
  `)}
`;

export const TitleFaq = styled.p`
  color: #000;
  font-size: 28px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
`;

export const ContainerTitleFaq = styled.div`
  text-align: center;
  padding: 3em 0;
`;

export const ContainerFaq = styled.div`
  margin: 0 auto;
  max-width: 600px;
  ${handleQuery(css`
    padding: 0 1em;
  `)}
`;

export const ContainerFooterFaq = styled.div`
  text-align: center;
  padding: 3em 0;
`;

export const TitleCtaFaq = styled.p`
  color: #000;
  font-size: 18px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  margin-bottom: 1em;
`;
